function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3286"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2987",
  d: "M307.419 48.219c-4.282-12-10.549-27.026-14-30.083-5.479-4.854-22.759-13.751-31.348-15.744C252.106.08 161.902.544 155.871 7.446s-14.304 37.483-14.304 37.483S7.657 48.348 5.355 50.054c-6.786 5.027-.538 67.016 6.411 69.427 4.572 1.586 144.138 71.184 152.842 70.271 7.578-.8 12.512 2.7 13.184 4.166.926 2.021-.967 18.321-.967 18.321l2.3 2.646 40.811-31.445s23.839-73.041 38.558-76.689 1.937 34.885 1.937 34.885l41.2-46.889s6.192-23.178 8.135-25.746c1.488-1.967.2 14.3.3 13.632",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2988",
  d: "M310.208 82.387c1.559-1.767 6.595-7.337 7.314-9.465.469-1.387.515-12.924.115-14.121-.372-1.109-1.713-2.14-2.938-3.076",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2989",
  d: "M305.231 49.965c-1.031-3.43-7.254-23-10.3-26.509s-17.607-10.761-22.818-11.569 7.732 41.77 9.44 42.532 24.708-1.025 23.678-4.454z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2990",
  d: "M284.214 16.619c2.872 6.1 8.609 33.551 8.472 37.221",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2991",
  d: "M301.223 63.955a27.3 27.3 0 01-.225 4.851l-3.432 2.405.165-6.056s3.277-2.571 3.492-1.2z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3283"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2992",
  d: "M286.308 71.358a27.3 27.3 0 01-.225 4.851l-3.432 2.406.165-6.057s3.279-2.57 3.492-1.2z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2993",
  d: "M262.108 4.121c7.423 3.214 11.143 41.432 14.766 53.639s6.093 16.387-.23 41.6c-5.964 23.78-6.4 31.143-6.4 31.143",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2994",
  d: "M264.189 52.796c1.248-7.242-3.13-40.543-10.21-42.631s-44.912-2.708-51.614-2.547c-5.835.144-43.112-.583-46.541 5.379s-13.344 31.709-11.91 31.789c19.213 1.078 120.069 9.208 120.275 8.01z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2995",
  d: "M273.326 57.7c-18.543 3.615-91.639 21.662-109.837 20.657S15.48 58.657 5.346 53.604",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2996",
  d: "M176.769 212.292c-3.665 5.4-11.609 19.23-25.547 15.372s-83.08-38-93.418-44.183-24.6-14.855-30.186-20.441-19.63-19.587-19.63-19.587-6.634-9.054-6.99-15.115a14.234 14.234 0 011.271-5.116c1.1-1.944 9.037-3.89 9.037-3.89",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2997",
  d: "M157.883 77.867c-3.377 12.346-10.819 85.379-4.529 108.206",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2998",
  d: "M151.231 168.732c6.7 2.29 8.238 3.411 9.679 3.419 4.424.024 12.646.722 17.553-1.242 1.06-.424 12.235-7.941 12.446-9.043 1.251-6.532 1.622-26.035 2.134-28.951.609-3.465 7.748-12.655 7.913-13.942.412-3.232 1.275-17.088.575-17.351-1.522-.575-15.634 5.269-18.592 6.024-4.021 1.026-18.979 1.2-24.882.917-1.5-.072-4.128-1.793-4.128-1.793",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2999",
  d: "M268.149 122.51c1.7-8.9 5.53-35.6-7.752-38.557-15.585-3.475-38.476 48.817-43.651 76.289",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3284"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 29",
  cx: 31.082,
  cy: 5.748,
  rx: 31.082,
  ry: 5.748,
  transform: "rotate(-74.7 247.178 -51.106)",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3285"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 30",
  cx: 43.743,
  cy: 10.933,
  rx: 43.743,
  ry: 10.933,
  transform: "rotate(-74.696 250.473 -38.768)",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3000",
  d: "M257.326 133.107c-1.7-3.494-10.927-7.844-13.6-8.217",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3001",
  d: "M233.369 216.011c-4.714-.006-12.94-2.052-19.43-5.238-5.2-2.554-5.755-5.567-6.159-7.357a28.8 28.8 0 01-.492-10.259",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3002",
  d: "M305.448 47.275c1.814 1.073 4.389 2 5.388.992.609-.612.6-5.161 1.439-5.695.891-.569 7.941-.674 9.045-.26a8.892 8.892 0 013.571 3.473c.449.9-.589 7.117-1.75 9.294-.474.887-13.006.112-15.967 1.21-.226.084-2.732 1.884-2.732 1.884",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3003",
  d: "M307.822 73.832c5.4 1.172-.808 38.971-6.137 40.834-5.738 2.007-10.041.117-11.494-1.713-1.057-1.331-1.534-2.89-1.214-3.833",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3004",
  d: "M55.64 68.683c1.351 3.142 2.309 11.949 2.309 11.949s-13.8-1.716-16.338-3.951-9.673-10.676-7.955-11.869 20.631.73 21.984 3.871z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3005",
  d: "M258.833 54.701l-96.9 15.819L16.725 50.372",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3006",
  d: "M86.922 159.416c5.157 3.055 10.225 3.349 4.48 5.424s-16.645 8.14-17.147 11.336 4.205 14.693-1.745 11.679-29.191-13.573-32.344-19.154-7.985-21.191-13.331-24.268-13.028-8.435-13.028-8.435",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3007",
  d: "M44.294 138.154l-16.392 7.08",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3008",
  d: "M47.739 141.293c1.953 4.928 1.784 16.635 8.949 20.651s19.757 11.2 19.757 11.2",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3009",
  d: "M78.059 177.273c15.465 7.925 66.665 34.019 72.69 34.732 3.857.455 10.486.015 14.017-1.33s9.6-6.709 9.6-6.709",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3010",
  d: "M142.635 49.848c.08 8.136-.882 17.858-.882 17.858",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgPassengerSideRearQuarterGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309.999,
    height: 229.334,
    viewBox: "0 0 326 229"
  }, props), _ref);
}

export default SvgPassengerSideRearQuarterGraphic;